export const nameToInputType = (name) => {
  if (
    process.env.VUE_APP_QUESTIONARIO_ID === "default" ||
    process.env.VUE_APP_QUESTIONARIO_ID === "massei"
  )
    switch (name) {
      case "email":
      case "telefon":
      case "mobile":
      case "first_name":
      case "last_name":
      case "telephone":
      case "piva":
      case "pec":
      case "codfisc":
      case "idcode":
      case "protocol_pec":
      case "birthplace":
      case "error_flux_code":
        return "textInput";
      case "question":
        return "textArea";
      case "birthday":
        return "date";
      case "contact_times":
      case "pgpf":
      case "legal":
      case "persona":
      case "elenco_registro":
      case "job":
      case "document_type_1":
      case "document_type_2":
        return "select";
      default:
        null;
    }
};

export const nameToInputPattern = (name) => {
  if (
    process.env.VUE_APP_QUESTIONARIO_ID === "default" ||
    process.env.VUE_APP_QUESTIONARIO_ID === "massei"
  )
    switch (name) {
      case "email":
      case "pec":
        return "[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?";
      case "telefon":
      case "mobile":
      case "piva":
        return "[0-9]+";
      default:
        null;
    }
};
export const nameToInputTextMaxLength = (name) => {
  switch (name) {
    case "piva":
      return "12"
    case "codfisc":
      return "16"
    case "idCode":
      return "8"
    case "birthplace":
      return "25"
    default:
      return null
  }
}

export const nameToInputTextType = (name) => {
  switch (name) {
    //case "piva":
    case "telefon":
    case "mobile":
      return "number"
    default:
      return "text"

  }
}

export const nameToSelectOptions = (name) => {
  switch (name) {
    case "contact_times":
      return [
        { value: '', text: "Seleziona" , selected: 'selected'},
        { value: "Dalle900alle1200", text: "Dalle 9:00 alle 12:00" },
        { value: "Dalle1500alle1800", text: "Dalle 15:00 alle 18:00" },
      ];
    case "pgpf":
      return [
        { value: '', text: "Seleziona", selected: true },
        { value: "Persona Fisica", text: "Persona Fisica" },
        { value: "Persona Giuridica", text: "Persona Giuridica" },
      ];
    case "legal":
      return [
        { value: '', text: "Seleziona" , selected: true},
        { value: "Yes", text: "Si" },
        { value: "No", text: "No" },
      ];
    case "persona":
      return [
        { value: '', text: "Seleziona" , selected: true},
        { value: "Persona Fisica", text: "Persona Fisica" },
        { value: "Persona Giuridica", text: "Persona Giuridica" },
      ];
    case "elenco_registro":
      return [
        { value: '', text: "Seleziona", selected: true },
        { value: "ElencoAgentieMediatori", text: "Elenco Agenti e Mediatori" },
        { value: "RegistroCambiavalute", text: "Registro Compro Oro" },
        {
          value: "RegistroOperatoriCriptoValute",
          text: "Registro Operatori Cripto Valute",
        },
      ];
    case "job":
      return [
        { value: '', text: "Seleziona", selected: true },
        {
          value:
            "Associazione di categoria Iscritti negli Elenchi e/o Registri OAM",
          text: "Associazione di categoria Iscritti negli Elenchi e/o Registri OAM",
        },
        {
          value: "Intermediario finanziario e bancario Istituto di pagamento",
          text: "Intermediario finanziario e bancario Istituto di pagamento",
        },
        {
          value:
            "Istituto di moneta elettronica Professionista, che formula la domanda in nome e per conto di un operatore iscritto in uno degli Elenchi e/o Registri OAM",
          text: "Istituto di moneta elettronica Professionista, che formula la domanda in nome e per conto di un operatore iscritto in uno degli Elenchi e/o Registri OAM",
        },
        {
          value: "Non appartengo a nessuna tra le precedenti categorie",
          text: "Non appartengo a nessuna tra le precedenti categorie",
        },
      ];
    case "document_type_1":
      return [
        { value: '', text: "Seleziona", selected: true },
        { value: "Tipo documento 2", text: "Tipo documento 2" },
      ];
    case "document_type_2":
      return [
        { value: '', text: "Seleziona" , selected: true},
        { value: "Cartadiidentita", text: "Carta di identita" },
        { value: "Patentediguida", text: "Patente di guida" },
        { value: "Passaporto", text: "Passaporto" },
      ];
    default:
      return [];
  }
};
